import $ from 'jquery';
import React from 'react';
import moment from 'moment';

const self = this;

const commonFunctions = {
  clone: function clone(data, deep) {
    const type = Object.prototype.toString.call(data);
    if (type === '[object Array]') {
      return $.extend(deep, [], data);
    } else if (type === '[object Object]') {
      return $.extend(deep, {}, data);
    }
  },
  addZero: function addZero(num) {
    const inte = Math.abs(num);
    if (num < 0) return (inte < 10) ? ('-0' +inte) : num;
    return (inte < 10) ? ('0' +inte) : num;
  },
  getUtcOffset: function getUtcOffset(offset) {
    return ' (GMT' + ((offset > 0) ? '+' : '') + this.addZero(parseInt((offset/1000)/3600)) + ':' + this.addZero(((offset/1000)%3600)/60) + ')';
  },
  sortByKey: function sortByKey(array, key, reverse = false) {
    return array.sort((a, b) => {
      let x, y;
      if (typeof key === 'object') {
        x = key.map((item) => this.addZero(a[item])).join('');
        y = key.map((item) => this.addZero(b[item])).join('');
      }
      else {
        x = a[key];
        y = b[key];
      }
      return reverse ? ((x > y) ? -1 : ((x < y) ? 1 : 0)) : ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  },
  toTitleCase: function toTitleCase(str) {
    return str.replace(/\w\S*/g, (txt)=> {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },
  join: function join(ary,joinDelmiter){
    if(typeof joinDelmiter == "string") return ary.join(joinDelmiter);
    else if(typeof joinDelmiter == "function"){
      let str = "";
      ary.forEach((item, idx) => {
        str += joinDelmiter(item,idx)+item;
      });
      return str;
    }
  },
  getLocation : function getLocation(href) {
      const match = href.match(/^(https?:)\/\/(([^:\/?#]*)(?::([0-9]+))?)(\/[^?#]*)(\?[^#]*|)(#.*|)$/);
      return match && {
          protocol: match[1],
          host: match[2],
          hostname: match[3],
          port: match[4],
          pathname: match[5],
          search: match[6],
          hash: match[7]
      }
  },
  debounce : function(callback, delay){
    let timeout;
    return function(){
      const args = Array.prototype.slice.call(arguments);
      if(timeout) clearTimeout(timeout);
      timeout = setTimeout(()=>{
        callback.apply(this,args);
      }, delay || 100);
    }
  },
  findIndexWithKey : function(ary, obj, key){
    for(let i=0,ln=ary.length; i< ln; i++){
      if(obj[key] === ary[i][key]){
        return i;
      }
    }
    return -1;
  },
  localTimestampToGMT : (localTimestamp) =>{
    let date  = new Date();
    let GMTTimestamp = new Date(localTimestamp + date.getTimezoneOffset() * 60000).getTime();
    return GMTTimestamp;
  },
  GMTTimeStampToLocal : (GMTTimestamp) =>{
    let date  = new Date();
    let localTimestamp = new Date(GMTTimestamp - date.getTimezoneOffset() * 60000).getTime();
    return localTimestamp;
  },
  startOftheDayTimestamp: (localTimestamp) => {
    // from local to utc timestamp
    // console.log(localTimestamp , "local");
    // let GMTTimeStamp =  commonFunctions.localTimestampToGMT(localTimestamp);
    // let startTimeStamp = new Date(GMTTimeStamp).setHours(0,0,0,0);
    // console.log('localTimestamp',localTimestamp,'GMTTimeStamp', GMTTimeStamp, 'startTimeStamp', startTimeStamp);
    return localTimestamp*1000;
  },
  endOftheDayTimestamp: (localTimestamp) => {
    // from local to utc timestamp
    // let GMTTimeStamp =  commonFunctions.localTimestampToGMT(localTimestamp);
    let eodTimeStamp = new Date(localTimestamp*1000).setHours(23,59,59,999);
    return eodTimeStamp;
  },
  getDateTime : (timestamp) => {
    const dateTimeObj = moment(timestamp).format("MMM DD,hh:mm A");
    const dateTimeString = dateTimeObj.split(",");
    return({
      date: dateTimeString[0],
      time: dateTimeString[1]
    })
  },
  toUpperCase: (string) => {
    return string.toUpperCase();
  }
}
module.exports = commonFunctions;



// WEBPACK FOOTER //
// app/util/common.jsx